export default "__VITE_ASSET__9dd7b53d__"